import styled from 'styled-components';

import { CFG } from '../../../../theme/configurator-tokens';
import { Text } from '../../../../components';

/** Centered loading / error state shown before the catalog is ready. */
export const Status = styled.div`
  display: flex;
  height: 320px;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  text-align: center;
`;

export const StatusText = styled(Text)`
  font-size: 14px;
  color: ${CFG.base500};
`;

export const ErrorText = styled(StatusText)`
  color: ${CFG.danger};
`;
